import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import * as Utils from "../../inc/Utils";
import DatePicker from "react-datepicker";
import Select from 'react-select'
import {getKol} from "../../inc/Utils";
import moment from "moment-timezone";

export default function AdsNamingCampaignCreateAdHocDuplicate() {
    const roles = new Role();
    let userId = roles.loginUserId;
    let typeId = Utils.ADSNAMING_GROUP_ADHOC_CAMPAIGN;

    //region duplicate
    let adsNamingId = null;
    let {encode} = useParams();
    if(encode) {
        let decode = Utils.decodeItem(encode);
        adsNamingId = decode.id;
    }
    //endregion

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [agency, setAgency] = React.useState('');
    let [lang, setLanguage] = React.useState('');
    let [campaignType, setCampaignType] = React.useState(''); 
    let [promotion, setPromotion] = React.useState('');
    let [campaignDate, setCampaignDate] = React.useState('');
    let [campaign, setCampaign] = React.useState('');
    let [adsNaming, setAdsNaming] = React.useState('');
    let [buType, setBuType] = React.useState(null);

    let [agencyId, setAgencyId] = React.useState(null);
    let [langId, setLanguageId] = React.useState(null);
    let [campaignTypeId, setCampaignTypeId] = React.useState(null);
    let [promotionId, setPromotionId] = React.useState(null);
    let [campaignId, setCampaignId] = React.useState(null);
    let [buTypeId, setBuTypeId] = React.useState(null);

    let [promotionPlaceholder, setPromotionPlaceholder] = React.useState('...');
    let [campaignPlaceholder, setCampaignPlaceholder] = React.useState('...');
    let [disableCampaignId, setDisableCampaignId] = React.useState(true);
    let [disablePromotion, setDisablePromotion] = React.useState(true);
    let [example, setExample] = React.useState('');
    let [kolPage, setKolPage] = React.useState('');
    let [preview, setPreview] = React.useState('');

    let [itemSlugPromotion, setItemSlugPromotion] = React.useState('');
    let [itemFreeForm, setItemFreeForm] = React.useState('');
    let [itemSelected, setItemSelected] = React.useState('');

    let [platform, setPlatform] = React.useState('');
    let [platformId, setPlatformId] = React.useState(null);

    const navigate = useNavigate(); 

    React.useEffect(() => {
        (async function() {
            try {
                const resPlatform = await Utils.getPlatformAll();
                setPlatform(resPlatform);

                //region default kol id
                const resKolPage = await getKol();
                setKolPage(resKolPage);

                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);
                const resCampaignType = await Utils.getCampaignType();
                setCampaignType(resCampaignType);
                const resBuType = await Utils.getBuType();
                setBuType(resBuType);

                //region set new agency
                const resAgency = await Utils.getAgencySlug();
                let newAgencies = [];
                if(resAgency) {
                    let newA = resAgency.find(e => e.id === roles.agencyId).items;
                    let ownerIds = [];
                    for(let a of newA) {
                        ownerIds.push(a.ownerId);
                    }
                    for(let ag of resAgency) {
                        if(ag.items.find(e => ownerIds.includes(e.ownerId))) {
                            newAgencies.push({
                                id: ag.id,
                                slug: ag.slug,
                                name: ag.name
                            })
                        }
                    }
                }
                setAgency(newAgencies);
                //endregion

                const resAdsNaming = await Utils.getAdsNamingCampaign();

                //region duplicate
                if(adsNamingId) {
                    const resView = await getView(adsNamingId);
                    if(resPlatform !== null && resView.adsPlatformId !== null) {
                        setPlatformId(resPlatform.filter(e => e.id === resView.adsPlatformId)[0]);
                    }

                    let sourceTypeSelectedIds = [];
                    if(resView) {
                        let items = resView.items;
                        if(items) {
                            for(let rs of items) {
                                let adsNamingSourceId = rs.adsNamingSourceId;
                                if(adsNamingSourceId) {
                                    if(rs.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                        sourceTypeSelectedIds.push(adsNamingSourceId + ':KOL' + rs.adsNamingId);
                                    }
                                    else {
                                        sourceTypeSelectedIds.push(adsNamingSourceId);
                                    }
                                }
                            }
                        }
                        setItemSelected(sourceTypeSelectedIds);
                    }

                    //setup default ads naming
                    if(resAdsNaming.length > 0) {

                        let ex = [];
                        if(resAdsNaming) {
                            for(let rs of resAdsNaming) {
                                if(rs.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROJECT && rs.inputType !== Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                    ex.push('{' + rs.name + '}');
                                }
                            }
                        }
                        setAdsNaming(resAdsNaming);
                        setExample('{Agency}|{BG}|' + ex.join('_') + '_[ST]|{Campaign ID}');

                        let items = resView.items;
                        resAdsNaming.map((rs, index2) => {
                            let inputType = rs.inputType;
                            if(inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                let newKolPageId = [];
                                if(resKolPage) {
                                    for(let row of resKolPage) {
                                        let json  = {
                                            id: row.id + ':KOL' + rs.id,
                                            name:  row.name
                                        };
                                        newKolPageId.push(json);
                                    }
                                    rs.source = newKolPageId;
                                }
                            }
                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                // -- empty
                            }
                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                if(items) {
                                    for(let item of items) {
                                        if(item.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION && item.text) {
                                            setItemSlugPromotion(item.text);
                                            break;
                                        }
                                    }
                                }
                            }
                            else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                if(items) {
                                    for(let item of items) {
                                        if(item.inputType === Utils.ADSNAMING_TYPE_FREEFORM && item.text) {
                                            setItemFreeForm(item.text);
                                            break;
                                        }
                                    }
                                }
                            }
                        })
                    }
                    setAdsNaming(resAdsNaming);
                    //end

                    if(resLanguage) {
                        for(let ln of resLanguage) {
                            if(ln.id === resView.lang) {
                                setLanguageId({id: ln.id, name: ln.name});
                                break;
                            }
                        }
                    }
                    if(resCampaignType) {
                        for(let ln of resCampaignType) {
                            if(ln.id === resView.campaignTypeId) {
                                setCampaignTypeId({id: ln.id, name: ln.name});
                                break;
                            }
                        }
                    }
                    if(resBuType) {
                        for(let ln of resBuType) {
                            if(ln.id === resView.buTypeId) {
                                setBuTypeId({id: ln.id, name: ln.name});
                                break;
                            }
                        }
                    }
                    if(resView.campaignDate){
                        setCampaignDate(new Date(resView.campaignDate));
                    }
                    if(resAgency) {
                        for(let ln of resAgency) {
                            if(ln.id === resView.agencyId) {
                                setAgencyId({id: ln.id, slug: ln.slug, name: ln.name});
                                break;
                            }
                        }
                    }
                    if(resView.lang && resView.campaignTypeId) {
                        await promotionChange(resView.lang, resView.campaignTypeId, resView.campaignDate, resView.buTypeId, resView);
                    }
                }
                //endregion
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    //region duplicate
    async function getView(id) {
        const response = await fetch(Config.url.API_URL +'/api/adsNamingCampaign/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }
    //endregion

    const onCreate = async () => {

        let param = await getParams();

        if(!langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(!campaignTypeId) {
            toast.error("กรุณาระบุ Campaign Type");
        }
        else if(!buTypeId) {
            toast.error("กรุณาระบุ BU Type");
        }
        else if(!promotionId) {
            toast.error("กรุณาระบุ Promotion");
        }
        else if(!agencyId) {
            toast.error("กรุณาระบุ Agency");
        }
        else if(!param.success) {
            toast.error("กรุณาเลือก Parameters ให้ครบถ้วน");
        }
        else if(!campaignId) {
            toast.error("กรุณาระบุ Campaign ID");
        }
        else if(param.params.length <=0 || param.params.length >= 200) {
            toast.error("ขนาดตัวอักษรต้องไม่เกิน 200");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            const body = {
                                adsPlatformId: platformId ? platformId.id:null,
                                lang: langId ? langId.id : null,
                                typeId: typeId,
                                campaignTypeId: campaignTypeId ? campaignTypeId.id : null,
                                buTypeId: buTypeId ? buTypeId.id : null,
                                projectCode: null,
                                campaignDate: campaignDate ? new Date(campaignDate) : null,
                                agencyId: agencyId ? agencyId.id : null,
                                campaignId: campaignId ? campaignId.campaign_id : null,
                                params: param.params,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                sourceTypeIds: param.data
                            };

                            fetch(Config.url.API_URL +'/api/adsNamingCampaign/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/adsNamingCampaign', {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeLanguageId = async (obj) => {
        setLanguageId(obj);
        setPromotion('');
        setPromotionId(null);
        setPromotionPlaceholder('...');
        setDisablePromotion(true);

        if(document.getElementById("slug-promotion")) {
            document.getElementById("slug-promotion").value = '';
        }

        if(obj && obj.id && campaignTypeId) {
            await promotionChange(obj.id, campaignTypeId.id, campaignDate);
        }
    };
    const onChangeCampaignTypeId = async (obj) => {
        setCampaignTypeId(obj);
        setPromotionId(null);
        setPromotion('');
        setPromotionPlaceholder('...');
        setDisablePromotion(true);

        setCampaignPlaceholder('...');
        setDisableCampaignId(true);
        setCampaignId(null);
        setCampaign('');

        if(document.getElementById("slug-promotion")) {
            document.getElementById("slug-promotion").value = '';
        }

        if(obj && obj.id && langId) {
            await promotionChange(langId.id, obj.id, campaignDate, buTypeId.id);
        }
    };
    const onChangeBuTypeId = async (obj) => {
        setBuTypeId(obj);
        setPromotion('');
        setPromotionId(null);
        setPromotionPlaceholder('...');
        setDisablePromotion(true);

        if(obj && obj.id && langId && campaignTypeId.id) {
            await promotionChange(langId.id, campaignTypeId.id, campaignDate, obj.id);
        }
    };
    const promotionChange = async (langId, campaignTypeId, campaignDate, buTypeId, resView = '') => {
        setPromotionPlaceholder('กำลังโหลด...');
        const resPromotion = await Utils.getPromotion({
            langId: langId,
            campaignTypeId: campaignTypeId,
            campaignDate: campaignDate,
            buTypeId: buTypeId
        });
        if(resPromotion && resPromotion.data) {
            setPromotion(resPromotion.data);
            setPromotionPlaceholder('Select...');
            setDisablePromotion(false);

            if(resView) {
                for(let ln of resPromotion.data) {
                    if(resView && resView.campaignId && ln.campaign_id === resView.campaignId) {
                        setPromotionId({
                            promotion_url: ln.promotion_url,
                            campaign_id: ln.campaign_id,
                            promotion_name: ln.promotion_name
                        });

                        if(resView.lang && resView.campaignTypeId) {
                            setCampaignPlaceholder('กำลังโหลด...');
                            const resPromotion = await Utils.getPromotion({
                                langId: resView.lang,
                                campaignTypeId: resView.campaignTypeId,
                                campaignDate: resView.campaignDate ?? null,
                                campaignId: resView.campaignId
                            });
                            setCampaignPlaceholder('Select...');
                            setDisableCampaignId(false);
                            if(resPromotion.data) {
                                let campaignList = [];
                                campaignList.push({
                                    campaign_id: '0638A01',
                                    campaign_name: 'NonDefine'
                                });
                                if(resPromotion.data) {
                                    for(let rs of resPromotion.data) {
                                        campaignList.push({
                                            campaign_id: rs.campaign_id,
                                            campaign_name: rs.campaign_name
                                        });
                                    }
                                }
                                setCampaign(campaignList);
                                for(let pt of campaignList) {
                                    if(pt.campaign_id === resView.campaignId) {
                                        setCampaignId({
                                            campaign_id: pt.campaign_id,
                                            campaign_name: pt.campaign_name
                                        });
                                    }
                                }
                            }
                        }
                        break;
                    }
                }
            }
        }
        else {
            setPromotion(null);
            setPromotionPlaceholder('ไม่พบข้อมูล..');
        }
    };
    const onChangePromotionId = async (obj) => {

        if(document.getElementById("slug-promotion")) {
            document.getElementById("slug-promotion").value = '';
        }

        setCampaignPlaceholder('...');
        setDisableCampaignId(true);
        setCampaignId(null);
        setCampaign('');
        setPromotionId(null);

        if(obj){
            setPromotionId({
                promotion_url: obj.promotion_url,
                campaign_id: obj.campaign_id,
                promotion_name: obj.promotion_name
            });
        }

        if(obj && langId && langId.id && campaignTypeId && campaignTypeId.id) {
            setCampaignPlaceholder('กำลังโหลด...');
            const resPromotion = await Utils.getPromotion({
                langId: langId.id,
                campaignTypeId: campaignTypeId.id,
                campaignDate: campaignDate ?? null,
                campaignId: obj ? obj.campaign_id:null
            });
            setCampaignPlaceholder('Select...');
            setDisableCampaignId(false);

            let campaignList = [];
            if(resPromotion.data) {
                campaignList.push({
                    campaign_id: '0638A01',
                    campaign_name: 'NonDefine'
                });
                for(let rs of resPromotion.data) {
                    campaignList.push({
                        campaign_id: rs.campaign_id,
                        campaign_name: rs.campaign_name
                    });
                }
            }
            setCampaign(campaignList);
        }

        if(document.getElementById("slug-promotion")) {
            let slug = '';
            if(obj) {
                let buTypeRow = await Utils.getBuTypeView(obj.bu_type);
                let buTypeCondition = buTypeRow.replace;

                if(campaignTypeId.id === Utils.CAMPAIGN_TYPE_ALL) {
                    slug = langId.id + '-promotion-' +buTypeCondition + '-' + obj.promotion_slug;
                }
                else if(campaignTypeId.id === Utils.CAMPAIGN_TYPE_SPECIAL) {
                    slug = langId.id + '-' +buTypeCondition + '-zone-' + obj.promotion_slug;
                }
                document.getElementById("slug-promotion").value = slug;
            }
            else {
                document.getElementById("slug-promotion").value = '';
            }
        }
    };
    const onChangeCampaignId = (obj) => {
        setCampaignPlaceholder('...');
        setCampaignId(obj);
    };
    const onChangeAgencyId = (obj) => {
        setAgencyId(obj);
    };
    const onChangeCampaignDate = async (value) => {
        setCampaignDate(value);
        setPromotion('');
        setPromotionId(null);
        if(langId && campaignTypeId && value) {
            await promotionChange(langId.id, campaignTypeId.id, new Date(value), buTypeId.id);
        }
    };
    const onPreviewUTM = async () => {
        const param = await getParams();
        setPreview(param.params);
    };

    async function getParams() {
        let textParams = [];
        let sourceIds = [];
        let kolIds = [];

        //STEP 1 : Find Selected
        let sourceTypeIds = [];
        let sourceTypeAllIds = [];
        let selectSourceTypeIds = document.getElementsByName('sourceTypeIds[]');
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                let sourceTypeId = st.value;
                if(sourceTypeId) {
                    //STEP 1.1 : Find special selector
                    if(sourceTypeId.includes(':KOL')) {
                        let sp = sourceTypeId.split(':KOL');
                        let kolId = sp[0];
                        let adsNamingId = sp[1];
                        if(kolId) {
                            let find = kolPage.find(rs => {
                                if(parseInt(rs.id) === parseInt(kolId)) {
                                    return rs;
                                }
                            });
                            kolIds.push({
                                adsNamingSourceId: parseInt(kolId),
                                adsNamingId: parseInt(adsNamingId),
                                name: find ? find.name : null,
                                inputType: Utils.ADSNAMING_TYPE_KOL_PAGE
                            });
                        }
                    }
                    else {
                        sourceTypeIds.push(sourceTypeId);
                    }
                    sourceTypeAllIds.push(sourceTypeId);
                }
            }
        }

        //STEP 2 : Get selector type
        if(sourceTypeIds.length > 0) {
            let result = await Utils.getSourceTypeForParam(sourceTypeIds);
            if(result) {
                for(let row of result) {
                    sourceIds.push({
                        adsNamingSourceId: row.id,
                        adsNamingId: row.adsNamingId,
                        name: row.name,
                        inputType: null
                    });
                }
            }
        }

        //STEP 4 : Get for params
        if(adsNaming.length > 0) {
            adsNaming.map(async (row, index) => {
                let value = '';
                let inputText = "sourceTypeText[" + row.id + "]";
                let textSourceTypeIds = document.getElementsByName(inputText);
                if(textSourceTypeIds && textSourceTypeIds[0]) {
                    value = textSourceTypeIds[0].value;
                    textParams.push({
                        adsNamingSourceId: null,
                        adsNamingId: row.id,
                        text: value,
                        inputType: row.inputType
                    });
                }
                else {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        if(kolIds) {
                            let find = kolIds.find(kol => {
                                if(kol.adsNamingId === row.id) {
                                    return kol;
                                }
                            });
                            if(find && find.name) {
                                textParams.push({
                                    adsNamingSourceId: find.adsNamingSourceId,
                                    adsNamingId: row.id,
                                    text: find.name,
                                    inputType: row.inputType
                                });
                            }
                        }
                    }
                    else {
                        let find = sourceIds.find(rs => {
                            if(parseInt(rs.adsNamingId) === parseInt(row.id)) {
                                return rs;
                            }
                        });
                        if(find && find.name) {
                            textParams.push({
                                adsNamingSourceId: find.adsNamingSourceId,
                                adsNamingId: row.id,
                                text: find.name,
                                inputType: null
                            });
                        }

                        if(row.name === 'Objective') {
                            let platformName = '';
                            if(platform && platformId !== null && platformId.id) {
                                platformName = platform.filter(e => e.id === platformId.id)[0].name;
                                textParams.push({
                                    adsNamingSourceId: null,
                                    adsNamingId: null,
                                    text: platformName,
                                    inputType: null
                                });
                            }
                        }
                    }
                }
            });
        }

        let agencySlug = '';
        if(agencyId && agencyId.id) {
            const resAgency = await Utils.getAgencyView(agencyId.id);
            agencySlug = resAgency.slug;
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        let params = agencySlug + '|' + bg + '|' + textParams.map(x => x.text).join('_') + '_[ST]|' + (campaignId ? campaignId.campaign_id:'');

        return {params: params, data: textParams, success: sourceTypeAllIds.length === selectSourceTypeIds.length};
    }

    const onChangePlatformId = (platformRow) => {
        setPlatformId(platformRow);
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Campaign Naming</div>
                    <span className="ms-1">/</span> <span className="text-muted">Promotion</span>
                    <span className="ms-1">/</span> <span className="text-muted">Duplicate</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="d-block mb-1 small">{example}</div>
                        <form>
                            <div className="row g-3 border rounded bg-light p-2 mt-0 mb-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={lang}
                                        onChange={(event) => onChangeLanguageId(event)}
                                        value={langId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="campaignTypeId" className="form-label">Campaign Type <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={campaignType}
                                        onChange={(event) => onChangeCampaignTypeId(event)}
                                        value={campaignTypeId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="buTypeId" className="form-label">BU Type <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={buType}
                                        onChange={(event) => onChangeBuTypeId(event)}
                                        value={buTypeId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="campaignDate" className="form-label">Campaign Date</label>
                                    <DatePicker
                                        selected={campaignDate}
                                        onChange={(date) => onChangeCampaignDate(date)}
                                        dateFormat="yyyy-MM-dd"
                                        wrapperClassName="w-100"
                                        className="form-control" />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="promotionId" className="form-label">Promotion Title <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        isDisabled={disablePromotion}
                                        classNamePrefix="form-select-search"
                                        placeholder={promotionPlaceholder}
                                        options={promotion}
                                        onChange={(event) => onChangePromotionId(event)}
                                        value={promotionId}
                                        getOptionValue={(option) => `${option.promotion_url}`}
                                        getOptionLabel={(option) => `${option.campaign_id} : ${option.promotion_name}`}
                                    />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="projectTypeId" className="form-label">Platform</label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={platform}
                                        onChange={(event) => onChangePlatformId(event)}
                                        value={platformId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                            </div>
                            <div className="row g-3 border rounded bg-light p-2 my-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="agency" className="form-label">Agency <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={agency}
                                        onChange={(event) => onChangeAgencyId(event)}
                                        value={agencyId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.slug}`}
                                    />
                                </div>
                            </div>
                            <div className="row g-3 border rounded bg-yellow-light p-2 my-3">
                                {
                                    adsNaming.length <= 0 ? (<p>ไม่พบข้อมูล Ads Naming</p>) :
                                        adsNaming.map((row, index) => {
                                            let inputText = "sourceTypeText[" + row.id + "]";
                                            let formId = '';
                                            let rsSource = row.source;
                                            let inputType = row.inputType;
                                            let selected = null;

                                            if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                                // -- empty
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                                // -- empty
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                                formId = 'slug-promotion';
                                                return (
                                                    <div key={index}>
                                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span>
                                                            <span className="text-muted small d-block fw-light">all = {'{lang}-promotion-{bu-type-condition}-{promotion-slug}'}</span>
                                                            <span className="text-muted small d-block fw-light">zone = {'{lang}-{bu-type-condition}-zone-{promotion-slug}'}</span>
                                                        </div>
                                                        <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} defaultValue={itemSlugPromotion} disabled={true} /></div>
                                                    </div>
                                                );
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                                formId = 'freeform';
                                                return (
                                                    <div key={index}>
                                                        <div className="d-block fw-bold">{row.name}</div>
                                                        <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} defaultValue={itemFreeForm} /></div>
                                                    </div>
                                                );
                                            }
                                            else {
                                                if(inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                                    for(let cs of rsSource) {
                                                        let id = cs.id;
                                                        let sp = id.split(':KOL');
                                                        let kol = parseInt(sp[0]) +':KOL'+ parseInt(row.id);
                                                        if(itemSelected.length && itemSelected.includes(kol)) {
                                                            selected = {id: id, name: cs.name};
                                                            break;
                                                        }
                                                    }
                                                    return (
                                                        <div key={index}>
                                                            <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                            <div className=" css-b62m3t-container">
                                                                <Select
                                                                    isClearable={true}
                                                                    name="sourceTypeIds[]"
                                                                    classNamePrefix="form-select-search"
                                                                    options={rsSource}
                                                                    defaultValue={selected}
                                                                    getOptionValue={(option) => `${option.id}`}
                                                                    getOptionLabel={(option) => `${option.name}`}
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                                else {
                                                    for(let cs of rsSource) {
                                                        let id = cs.id;
                                                        if(itemSelected.length && itemSelected.includes(id)) {
                                                            selected = {id: id, name: cs.name};
                                                            break;
                                                        }
                                                    }

                                                    if(platformId !== null && row.name !== 'BG' && row.name !== 'AgencyMaster') {
                                                        return (
                                                            <div key={index}>
                                                                <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                <div className=" css-b62m3t-container">
                                                                    <Select
                                                                        isClearable={true}
                                                                        name="sourceTypeIds[]"
                                                                        classNamePrefix="form-select-search"
                                                                        options={rsSource.filter(o => o.platform.some(e => e.adsPlatformId === platformId.id))}
                                                                        defaultValue={selected}
                                                                        getOptionValue={(option) => `${option.id}`}
                                                                        getOptionLabel={(option) => `${option.name}`}
                                                                    />
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    else {
                                                        return (
                                                            <div key={index}>
                                                                <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                <div className=" css-b62m3t-container">
                                                                    <Select
                                                                        isClearable={true}
                                                                        name="sourceTypeIds[]"
                                                                        classNamePrefix="form-select-search"
                                                                        options={rsSource}
                                                                        defaultValue={selected}
                                                                        getOptionValue={(option) => `${option.id}`}
                                                                        getOptionLabel={(option) => `${option.name}`}
                                                                    />
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                }
                                            }
                                        })
                                }
                            </div>

                            <div className="row g-3 border rounded bg-green-light p-2 my-3">
                                <div className="col-12">
                                    <label htmlFor="campaignId" className="form-label">Campaign ID <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        isDisabled={disableCampaignId}
                                        classNamePrefix="form-select-search"
                                        placeholder={campaignPlaceholder}
                                        options={campaign}
                                        onChange={(event) => onChangeCampaignId(event)}
                                        value={campaignId}
                                        getOptionValue={(option) => `${option.campaign_id}`}
                                        getOptionLabel={(option) => `${option.campaign_id} : ${option.campaign_name}`}
                                    />
                                </div>
                            </div>

                            <div className="d-block mb-1 small">{example}</div>
                            <div className="row g-3 border rounded bg-green-light p-2 my-3">
                                <div className="col-12 mt-0">
                                    <label htmlFor="preview" className="form-label"><button type="button" className="btn btn-sm btn-light" onClick={onPreviewUTM} disabled={!agencyId}>Preview</button></label>
                                    <div className="noselect-url w100 rounded">{preview}</div>
                                    <p className="mt-2 mb-0">ตัวอักษร : {preview.length}</p>
                                </div>
                            </div>

                            <div className="row g-3">
                                <div className="col-12">
                                    <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                        className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                    <NavLink className="btn btn-sm btn-light ms-2" to='/adsNamingCampaign'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                    <Toaster position="bottom-right" />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 